import { X } from "lucide-react";

export default function InlineForm({ placeholder, value, setValue, onClose, onSubmit, submitLabel, testIdPrefix, busy, note }) {
  return (
    <div className="mt-3 rounded-lg border border-slate-200 bg-white p-3" data-testid={`${testIdPrefix}-wrap`}>
      <textarea
        data-testid={`${testIdPrefix}-input`}
        rows={3}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full text-sm rounded-md border border-slate-300 p-2"
      />
      {note && <div className="text-xs text-slate-500 mt-1">{note}</div>}
      <div className="flex justify-end gap-2 mt-2">
        <button
          data-testid={`${testIdPrefix}-cancel`}
          onClick={onClose}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-sm hover:bg-slate-100 text-slate-700"
        >
          <X className="w-3.5 h-3.5" /> Cancel
        </button>
        <button
          data-testid={`${testIdPrefix}-submit`}
          onClick={onSubmit}
          disabled={busy}
          className="px-3 py-1.5 rounded-md text-sm bg-[#1B4332] text-white hover:opacity-90 disabled:opacity-60"
        >
          {submitLabel}
        </button>
      </div>
    </div>
  );
}
